import { useCallback } from 'react';

export const useTableFormatter = () => {
  const formatValue = useCallback((value) => {
    if (value === null || value === undefined) {
      return <span className="empty-value">—</span>;
    }
    if (typeof value === 'boolean') {
      return value ? '✓' : '✗';
    }
    if (typeof value === 'number') {
      return value.toLocaleString('ru-RU');
    }
    // Handle array of people objects
    if (Array.isArray(value) && value.length > 0) {
      // Filter out null/undefined items
      const validItems = value.filter(item => item !== null && item !== undefined);
      if (validItems.length === 0) {
        return <span className="empty-value">—</span>;
      }
      
      if (typeof validItems[0] === 'object') {
        // Check if objects have 'name' property
        if (validItems[0].name !== undefined) {
          // Multi-select or rollup array with name, or people with name
          return validItems.map(s => s.name || s.id || String(s)).filter(Boolean).join(', ');
        }
        // Check if objects have 'id' property
        if (validItems[0].id !== undefined) {
          // People or relation array
          return validItems.map(p => p.name || p.id || String(p)).filter(Boolean).join(', ');
        }
        // Try to stringify objects
        const strValue = String(validItems[0]);
        if (strValue === '[object Object]') {
          console.warn('Array contains objects without name/id:', validItems[0]);
          return <span className="empty-value">—</span>;
        }
      } else {
        // Array of primitives
        return validItems.join(', ');
      }
    }
    // Handle single select object
    if (typeof value === 'object' && !Array.isArray(value)) {
      if (value.name) {
        return value.name;
      }
      // Fallback: try to stringify object safely
      if (value.toString && value.toString() !== '[object Object]') {
        return value.toString();
      }
    }
    // Handle JSON strings that might contain select/rollup objects
    const strValue = String(value);
    if (strValue.startsWith('{') && (strValue.includes('"select"') || strValue.includes('"multi_select"') || strValue.includes('"rollup"'))) {
      try {
        const parsed = JSON.parse(strValue);
        // Handle rollup with array
        if (parsed.rollup && parsed.rollup.type === 'array' && parsed.rollup.array) {
          const items = [];
          parsed.rollup.array.forEach(item => {
            if (item.multi_select && Array.isArray(item.multi_select)) {
              items.push(...item.multi_select.map(s => s.name));
            } else if (item.select && item.select.name) {
              items.push(item.select.name);
            }
          });
          return items.length > 0 ? items.join(', ') : strValue;
        }
        // Handle select
        if (parsed.select && parsed.select.name) {
          return parsed.select.name;
        }
        // Handle multi_select
        if (parsed.multi_select && Array.isArray(parsed.multi_select)) {
          return parsed.multi_select.map(s => s.name).join(', ');
        }
        // Handle status
        if (parsed.status && parsed.status.name) {
          return parsed.status.name;
        }
      } catch (e) {
        // Not valid JSON, continue
      }
    }
    if (strValue === '[object Object]') {
      console.warn('Found [object Object] string, value:', value);
      return <span className="empty-value">—</span>;
    }
    return strValue;
  }, []);

  return {
    formatValue
  };
};

